import _ from 'underscore';

import {naturalSort, omitNull} from 'common/utils';


export default class Region {
  /* eslint-disable camelcase */
  constructor({
    region_id,
    name,
    geometry,
  }) {
    this.regionId = region_id || null;
    this.name = name || null;
    this.geometry = geometry || null;
  }
  /* eslint-enable camelcase */

  clone() {
    return new Region(this.serialize());
  }

  compare(other) {
    return naturalSort.compare(this.name, other.name);
  }

  serialize() {
    return omitNull({
      region_id: this.regionId,
      name: this.name,
      geometry: this.geometry,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/types/Region.js